import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Sales = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Activities: {
    Activities: lazyNamed(() => import('./containers/Activities/pages/Activities.tsx'), 'Activities'),
    ActivityForm: lazyNamed(() => import('./containers/Activities/pages/ActivityForm/index.tsx'), 'ActivityForm'),
    Comments: lazyNamed(() => import('./containers/Activities/pages/Comments.tsx'), 'Comments'),
  },
  RoleBasedRedirector: lazy(() => import('./components/RoleBasedRedirector.tsx')),

  Promotions: {
    List: lazy(() => import('./containers/Promotions/pages/PromotionList/index.ts')),
    TypeConfigList: lazy(() => import('./containers/Promotions/pages/TypeConfigList/index.ts')),
    Create: lazy(() => import('./containers/Promotions/pages/PromotionForm/Create.tsx')),
    Edit: lazy(() => import('./containers/Promotions/pages/PromotionForm/Edit.tsx')),
    AddAccounts: lazy(() => import('./containers/Promotions/pages/PromotionAddAccounts/index.tsx')),
    AddContacts: lazy(() => import('./containers/Promotions/pages/PromotionAddContacts/index.ts')),
    MailTemplate: lazy(() => import('./containers/Promotions/pages/PromotionMailTemplate/index.ts')),
    Layout: lazy(() => import('./containers/Promotions/components/Layout.tsx')),
  },

  PromotionsV2: {
    Promotions: lazyNamed(() => import('./containers/PromotionsV2/pages/Promotions/index.tsx'), 'Promotions'),
    TypeConfigs: lazyNamed(() => import('./containers/PromotionsV2/pages/TypeConfigs/index.tsx'), 'TypeConfigs'),
    ManagePromotion: lazyNamed(() => import('./containers/PromotionsV2/pages/ManagePromotion/index.tsx'), 'ManagePromotion'),
    PromotionDetails: lazyNamed(() => import('./containers/PromotionsV2/pages/PromotionDetails/index.tsx'), 'PromotionDetails'),
    PromotionMailTemplate: lazyNamed(
      () => import('./containers/PromotionsV2/pages/PromotionMailTemplate/index.tsx'),
      'PromotionMailTemplate',
    ),
    PromotionAddAccounts: lazyNamed(() => import('./containers/PromotionsV2/pages/PromotionAddAccounts/index.tsx'), 'PromotionAddAccounts'),
    PromotionAddContacts: lazyNamed(() => import('./containers/PromotionsV2/pages/PromotionAddContacts/index.tsx'), 'PromotionAddContacts'),
  },

  PromotionDetails: {
    Layout: lazy(() => import('./containers/Promotions/pages/Promotion/Layout.tsx')),
    Renderer: lazy(() => import('./containers/Promotions/pages/Promotion/index.tsx')),
    Providers: lazy(() => import('./containers/Promotions/components/PromotionDetailsProviders.tsx')),
  },

  Settings: {
    SalesfunnelLabels: lazyNamed(() => import('./containers/Settings/containers/SalesfunnelLabels/index.tsx'), 'SalesfunnelLabels'),
    Sources: lazyNamed(() => import('./containers/Settings/containers/Sources/index.tsx'), 'Sources'),
    TaskTopics: lazyNamed(() => import('./containers/Settings/containers/TaskTopics/index.tsx'), 'TaskTopics'),
  },

  Tasks: {
    Details: lazyNamed(() => import('./containers/Tasks/pages/TaskDetails/index.tsx'), 'TaskDetails'),
    Form: lazyNamed(() => import('./containers/Tasks/pages/TaskForm/index.tsx'), 'TaskForm'),
    Tables: lazyNamed(() => import('./containers/Tasks/pages/TaskTables/index.tsx'), 'TaskTables'),
  },
};

export default Sales;
